import { Trans, useTranslation } from 'next-i18next'
import { without } from 'ramda'

import {
  Heading2,
  LinkGrid,
  LinkText,
  Section2
} from '@/features/Listings/seo/elements'
import { Label } from '@/components/text'

import { getPopularCitiesByState } from './utils'

const PopularCities = ({
  state,
  citySlug = [],
  location,
  isCanadaPage
}: {
  state: string
  citySlug: string[]
  location: string
  isCanadaPage: boolean
}) => {
  const { t } = useTranslation()
  const cityLinks = getPopularCitiesByState(state)

  return (
    <Section2>
      <Heading2>
        {isCanadaPage ? (
          t('seo:Popular Cities in Canada')
        ) : (
          <Trans
            i18nKey="seo:Popular Cities Near LOCATION"
            values={{
              location
            }}
            defaults="Popular Cities Near {{ location }}"
          />
        )}
      </Heading2>
      <LinkGrid linksOnly>
        {without(citySlug, cityLinks).map(slug => {
          const name = t(`cities:city_name_${slug}`)
          return (
            <Label key={slug} fontSize="14px">
              <LinkText href={`/rental-listings/city/${slug}`}>
                <Trans
                  i18nKey="seo:city apartments for rent"
                  values={{ cityName: name }}
                  defaults="{{ cityName }} apartments for rent"
                />
              </LinkText>
            </Label>
          )
        })}
      </LinkGrid>
    </Section2>
  )
}

export default PopularCities
